import SettingsLayout from "@/components/SettingsLayout";
import { SettingsList, SettingsListItem } from "@/components/SettingsList";
import { formatTimestamp } from "@/lib/dates";
import { csrfToken } from "@/lib/fetchSideEffect";

interface DeletedTask {
  id: string;
  title: string;
  discardedAt: string;
}

export default function RecentlyDeleted({ tasks }: { tasks: DeletedTask[] }) {
  return (
    <SettingsLayout active="trash" title="Недавно удалённые">
      {tasks.length === 0 ? (
        <p className="text-sm text-gray-500">Ничего не удаляли недавно.</p>
      ) : (
        <>
          <p className="text-sm text-gray-500">Задачи хранятся здесь 30 дней, потом удаляются навсегда.</p>
          <SettingsList>
            {tasks.map((t) => (
              <SettingsListItem
                key={t.id}
                title={t.title}
                meta={<>Удалено {formatTimestamp(t.discardedAt)}</>}
                action={
                  <form method="POST" action={`/settings/trash/${t.id}/restore`}>
                    <input type="hidden" name="authenticity_token" value={csrfToken()} />
                    <input type="hidden" name="_method" value="patch" />
                    <button type="submit" className="text-sm text-blue-600 hover:text-blue-700 dark:text-blue-400">
                      Восстановить
                    </button>
                  </form>
                }
              />
            ))}
          </SettingsList>
        </>
      )}
    </SettingsLayout>
  );
}
